import { theme } from '@acorns/grove'
import { Page as BasePage } from '@acorns/web-components'
import styled from 'styled-components'

export const PAGE_PADDING_SM = 30

export const Page = styled(BasePage)`
  > div {
    padding-top: 10px;
  }

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    margin-top: 30px;

    #page-card {
      display: inline-block;
      padding: 80px 0 0;
      min-height: unset;

      > div {
        padding: unset;
      }
    }
  }
`

export const ContentContainer = styled.div<{ offsetHeight: number }>`
  margin-bottom: ${(props) => props.offsetHeight}px;

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    max-width: 340px;
    margin: 0 auto 80px;
  }
`

export const Headline = styled.p<{ hasExtraSpacing: boolean }>`
  font-weight: 600;
  font-size: 22px;
  line-height: 30px;
  margin-top: 0;
  margin-bottom: ${(props) => (props.hasExtraSpacing ? 30 : 10)}px;
  white-space: pre-line;
`

export const Subtitle = styled.p`
  margin-top: 0;
  margin-bottom: 30px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: ${theme.colors.primaryStone};
`

export const FooterContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 20px 30px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: ${theme.colors.primaryWhite};

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    position: unset;
    padding-top: 30px;
    padding-bottom: 30px;
    border-bottom-left-radius: ${theme.borderRadius.large};
    border-bottom-right-radius: ${theme.borderRadius.large};
  }
`
